import { PlayerNumber } from '~/modules/players/player-number';

/** Highest score first; a tie keeps seat order, so equal singers don't swap places every frame. */
export const rankPlayers = (scores: readonly (readonly [PlayerNumber, number])[]) =>
  [...scores].sort((a, b) => b[1] - a[1] || a[0] - b[0]).map(([number]) => number);
